




































import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    my_getSystemImg(menu:any) {                          // 当前组件
        let name = menu.menu_imgurl
        if (utils.formatPageName(menu.menu_linkurl) === this.page.pageTitle) {
            name = name + "_select"
        }
        return utils.getSystemImg({name})
    }
    open2 (a:any, aa:any) {
        this.goto(a, aa)
    }
    close2 (a:any, aa:any) {
        this.goto(a, aa)
    }
    goto (a:any, aa:any) {
        this.current.getGoToUrl(aa[aa.length-1])
    }
    getNum (menu_name:string) {
        if(utils.isNotNull(this.statistics_number[menu_name])){
            return this.statistics_number[menu_name]
        }else{
            return "";
        }
    }
}
